// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import translate from "@insite/client-framework/Translate";
import { VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
// import Select, { SelectPresentationProps } from "@insite/mobius/Select"; // Valtech Custom Code
import React from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Select, { SelectPresentationProps } from "@store/MobiusOverrides/Select/Select";
import { swatchProps } from "@store/Themes/common/props/swatch";
import useSwatchSelectedAccessibleText from "@toolkit/Framework/Common/Hooks/useSwatchSelectedAccessibleText";
/* Valtech Custom Code */

interface Props {
    variantSelection: SafeDictionary<string>;
    variantTrait: VariantTraitModel;
    updateVariantSelection: (traitValueId: string, variantTraitId: string) => void;
}

export interface ProductDetailsVariantDropdownStyles {
    select?: SelectPresentationProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
}

export const productDetailsVariantDropdownStyles: ProductDetailsVariantDropdownStyles = {
    /* Valtech Removed - styles */
};

const styles = productDetailsVariantDropdownStyles;

const ProductDetailsVariantDropdown = ({ variantSelection, updateVariantSelection, variantTrait }: Props) => {
    const swatchSelectedAccessibleText = useSwatchSelectedAccessibleText(variantTrait); // Valtech Custom Code

    return (
        <Select
            {...styles.select}
            key={variantTrait.id}
            label={variantTrait.nameDisplay}
            value={variantSelection[variantTrait.id]}
            onChange={event => {
                updateVariantSelection(event.currentTarget.value, variantTrait.id);
            }}
            data-test-selector={`styleSelect_${variantTrait.name}`}
            // Valtech Custom Code
            uid={variantTrait.id}
            labelAccessibleText={swatchSelectedAccessibleText}
        >
            <option value="" key={variantTrait.id}>
                {variantTrait.unselectedValue
                    ? variantTrait.unselectedValue
                    : `${translate("Select")} ${variantTrait.nameDisplay}`}
            </option>
            {variantTrait.traitValues?.map(traitValue => (
                <option value={`${traitValue.id}`} key={`${traitValue.id}`} disabled={traitValue.isDisabled}>
                    {traitValue.valueDisplay}
                </option>
            ))}
        </Select>
    );
};

export default ProductDetailsVariantDropdown;
